import React from 'react';
import Helmet from "react-helmet";

export default ({ titoloSezione, link, linkSrc }) => (
    <div className="embed-custom">
        <Helmet>
            <script src="https://embedr.flickr.com/assets/client-code.js" charset="utf-8"/>
        </Helmet>
        <h3>{titoloSezione}</h3>
        
        <div className="embed-flickr" dangerouslySetInnerHTML={{ __html: link ? link : '' }}>
        </div>
    </div>
);
